<div [class.row]="direction === 'column'" [class.no-gutters]="direction === 'column'" [class.valg-checkbox-group-row]="direction === 'row'" [class.valg-checkbox-group-column]="direction === 'column'">
  <ng-container *ngFor="let c of collectionColumns; let ci = index">
    <div  [class.col]="direction === 'column'" [class.d-flex]="direction === 'row'">
      <div class="valg-checkbox__wrapper" *ngIf="ci == 0 && canSelectAll">
        <input
          type="checkbox"
          class="valg-checkbox__input"
          [id]="id + '-selectAll'"
          [name]="id"
          (blur)="onBlur()"
          (click)="toggleSelectAll()"
          [checked]="isAllChecked()"
          [attr.aria-checked]="isAllChecked() ? 'true': this.checkedList.length !== 0 ? 'mixed' : 'false'"
          [disabled]="control.disabled ?? false"
        />
        <label class="valg-checkbox" [for]="id + '-selectAll'">
          {{ selectAllTitle | translate }}
        </label>
      </div>
      <div class="valg-checkbox__wrapper" *ngFor="let o of c; let i = index">
          <input
            type="checkbox"
            class="valg-checkbox__input"
            [ngClass]="{'larger': larger}"
            #checkbox
            [id]="id + '-' + ci +'-'+ i"
            [name]="id"
            [checked]="checkboxSelect(o.value)"
            (blur)="onBlur()"
            (click)="toggleCheck(o.value)"
            [disabled]="o.disabled || (control.disabled ?? false)"
          />
          <label class="valg-checkbox" [for]="id + '-' + ci + '-' + i">
              <span *ngIf="o.label !== ''">
                  {{ o.label | translate }}
              </span>
              <span *ngIf="o.label === ''" class="sr-only">
                  {{ "checkbox_group.empty_label" | translate }}
              </span>
          </label>
      </div>
    </div>
  </ng-container>
</div>